import { create } from 'zustand'

export type TaskStatus =
  | 'pending'
  | 'running'
  | 'completed'
  | 'failed'
  | 'cancelled'
  | 'paused'

export interface SubTask {
  id: string
  title: string
  status: TaskStatus
}

export interface Task {
  id: string
  title: string
  description?: string
  status: TaskStatus
  progress: number
  errorMessage?: string
  subTasks: SubTask[]
  createdAt: Date
  updatedAt: Date
}

interface TaskState {
  tasks: Task[]
  isLoading: boolean
  error: string | null

  setTasks: (tasks: Task[]) => void
  addTask: (task: Task) => void
  updateTask: (id: string, updates: Partial<Task>) => void
  removeTask: (id: string) => void
  setLoading: (isLoading: boolean) => void
  setError: (error: string | null) => void
}

export const useTaskStore = create<TaskState>((set) => ({
  tasks: [],
  isLoading: false,
  error: null,

  setTasks: (tasks) => {
    set({ tasks })
  },

  addTask: (task) => {
    set((state) => ({
      tasks: [task, ...state.tasks],
    }))
  },

  updateTask: (id, updates) => {
    set((state) => ({
      tasks: state.tasks.map((task) =>
        task.id === id ? { ...task, ...updates, updatedAt: new Date() } : task
      ),
    }))
  },

  removeTask: (id) => {
    set((state) => ({
      tasks: state.tasks.filter((task) => task.id !== id),
    }))
  },

  setLoading: (isLoading) => {
    set({ isLoading })
  },

  setError: (error) => {
    set({ error })
  },
}))
